import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { sum, calculation, numConvert } from '@/method';

const totalIndex = [0, 19, 24, 46, 50];
const oneRow = [0, 19, 46, 50];
const inputIndex = [47, 48, 51];
const percentIndex = [2, 6, 21, 23, 25, 32, 35, 37, 39, 41, 44];
const corKpis = {
    1: 5,
    2: 2,
    3: 3,
    4: 4,
    5: 6,
    6: 12,
    17: 7,
    18: 8,
    20: 15,
    21: 16,
    22: 17,
    23: 18,
};

const corKpisLast = {
    25: 2,
    26: 6,
    31: 13,
    32: 14,
    33: 6,
    43: 21,
    44: 22
};

const cor5 = {
    7: 2,
    8: 1,
    9: { index: 1, name: 'AC' },
    10: { index: 1, name: 'covers' },
    11: 0,
    12: { index: 0, name: 'AC' },
    13: { index: 0, name: 'covers' },
    14: 3,
    15: 4,
    16: 5,
};

const cor5Last = {
    34: 13,
    35: { index: 13, name: 'cost_percent' },
    36: 1,
    37: { index: 1, name: 'cost_percent' },
    38: 0,
    39: { index: 0, name: 'cost_percent' },
    40: 3,
    41: { index: 3, name: 'cost_percent' },
};


const cor8 = {
    27: 0,
    28: 1,
    29: 2,
    30: 3
};

export const compute = (data, { _5_1_1, _5_1_3, _5_1_4, _5_1_2, kpis, _8_1 }) => {
    Object.entries(corKpis).forEach(x => {
        data[x[0]].m_act = _.get(kpis, `${x[1]}.actual`, 0);
        data[x[0]].m_bud = _.get(kpis, `${x[1]}.budget`, 0);
        data[x[0]].m_var = _.get(kpis, `${x[1]}.actual_budget`, 0);
        data[x[0]].y_act = _.get(kpis, `${x[1]}.year_actual`, 0);
        data[x[0]].y_bud = _.get(kpis, `${x[1]}.budget`, 0);
        data[x[0]].y_var = _.get(kpis, `${x[1]}.actual_budget`, 0);
    });

    Object.entries(cor5).forEach(x => {
        let name = "REV";
        let index = x[1];
        if (typeof x[1] === 'object') {
            name = x[1].name;
            index = x[1].index;
        }
        data[x[0]].m_act = _.get(_5_1_1, `${index}.${name}`, 0);
        data[x[0]].m_bud = _.get(_5_1_1, `${index}.m_${name}`, 0);
        // data[x[0]].m_var = _.get(_5_1_1, `${index}.b_${name}`, 0);
        data[x[0]].m_var = calculation(data[x[0]].m_act - data[x[0]].m_bud, data[x[0]].m_bud);
        data[x[0]].y_act = _.get(_5_1_3, `${index}.${name}`, 0);
        data[x[0]].y_bud = _.get(_5_1_3, `${index}.m_${name}`, 0);
        // data[x[0]].y_var = _.get(_5_1_3, `${index}.b_${name}`, 0);
        data[x[0]].y_var = calculation(data[x[0]].y_act - data[x[0]].y_bud, data[x[0]].y_bud);
    });

    Object.entries(cor8).forEach(x => {
        data[x[0]].m_act = _.get(_8_1, `${x[1]}.cma_thisyear_consumption`, 0);
        data[x[0]].m_bud = _.get(_8_1, `${x[1]}.cma_lastyear_consumption`, 0);
        data[x[0]].m_var = _.get(_8_1, `${x[1]}.cmv_comparison_consumption_percent`, 0);
        data[x[0]].y_act = _.get(_8_1, `${x[1]}.ytda_thisyear_consumption`, 0);
        data[x[0]].y_bud = _.get(_8_1, `${x[1]}.ytda_lastyear_consumption`, 0);
        data[x[0]].y_var = _.get(_8_1, `${x[1]}.ytdv_comparison_consumption_percent`, 0);
    });


    Object.entries(corKpisLast).forEach(x => {
        data[x[0]].m_act = _.get(kpis, `${x[1]}.actual`, 0);
        data[x[0]].m_bud = _.get(kpis, `${x[1]}.last_year`, 0);
        data[x[0]].m_var = _.get(kpis, `${x[1]}.actual_last_year`, 0);
        data[x[0]].y_act = _.get(kpis, `${x[1]}.year_actual`, 0);
        data[x[0]].y_bud = _.get(kpis, `${x[1]}.year_last_year`, 0);
        data[x[0]].y_var = _.get(kpis, `${x[1]}.year_actual_last_year`, 0);
    });

    Object.entries(cor5Last).forEach(x => {
        let name = "REV";
        let index = x[1];
        if (typeof x[1] === 'object') {
            name = x[1].name;
            index = x[1].index;
        }
        data[x[0]].m_act = _.get(_5_1_2, `${index}.${name}`, 0);
        data[x[0]].m_bud = _.get(_5_1_2, `${index}.m_${name}`, 0);
        // data[x[0]].m_var = _.get(_5_1_2, `${index}.b_${name}`, 0);
        data[x[0]].m_var = calculation(data[x[0]].m_act - data[x[0]].m_bud, data[x[0]].m_bud);
        data[x[0]].y_act = _.get(_5_1_4, `${index}.${name}`, 0);
        data[x[0]].y_bud = _.get(_5_1_4, `${index}.m_${name}`, 0);
        // data[x[0]].y_var = _.get(_5_1_4, `${index}.b_${name}`, 0);
        data[x[0]].y_var = calculation(data[x[0]].y_act - data[x[0]].y_bud, data[x[0]].y_bud);
    });

    return data
}

export const columns = (onChange, date, print) => {
    const sqlName = "month_review";
    const month = moment(date).format('MMMM');
    let key = [{
        title: 'key',
        dataIndex: 'sort',
        key: 'sort',
        align: "center",
        width: 50,
        render: t => {
            return t
        }
    }];
    if (process.env.NODE_ENV != 'development') key = [];
    return [
        ...key,
        {
            title: '指标',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 200,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                if (oneRow.includes(index)) {
                    return {
                        props: {
                            colSpan: 7
                        },
                        children: <TableText data={{ ...props, type: "textcenter" }} />
                    }
                }
                return <TableText data={props} />
            }
        }, {
            title: month,
            align: "center",
            children: [{
                title: 'Actual',
                dataIndex: 'm_act',
                key: 'm_act',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    let props = {
                        text,
                        index,
                        type: percentIndex.includes(index) ? "percent" : 'number',
                        name: "m_act",
                        onChange,
                        totalIndex,
                    };
                    if (oneRow.includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    if (index === 24) {
                        return <TableText data={{ ...props, type: "textcenter", text: "Actual" }} />
                    }
                    if (index === 52) {
                        return {
                            props: {
                                colSpan: 6
                            },
                            children: <TableText data={{ ...props, type: 'textArea' }} />
                        }
                    }
                    if ([42, 49].includes(index)) {
                        return {
                            props: {
                                colSpan: 3
                            },
                            children: <TableText data={{ ...props, type: 'input' }} />
                        }
                    }
                    if (index == 45) {
                        return {
                            props: {
                                colSpan: 3
                            },
                            children: <TableText data={{ ...props, type: 'inputPercent' }} />
                        }
                    }
                    if (inputIndex.includes(index)) props.type = "inputNumber";
                    return <TableText data={props} />
                }
            }, {
                title: 'Budget',
                dataIndex: 'm_bud',
                key: 'm_bud',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    let props = {
                        text,
                        index,
                        type: percentIndex.includes(index) ? "percent" : 'number',
                        name: "m_bud",
                        onChange,
                        totalIndex,
                    };
                    if (oneRow.includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    if (index === 24) {
                        return <TableText data={{ ...props, type: "textcenter", text: "Last Year" }} />
                    }
                    if ([42, 45, 49, 52].includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            },
                        }
                    }
                    if (inputIndex.includes(index)) props.type = "inputNumber";
                    return <TableText data={props} />
                }
            }, {
                title: 'Var%',
                dataIndex: 'm_var',
                key: 'm_var',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    let props = {
                        text,
                        index,
                        type: 'percent',
                        name: "m_var",
                        onChange,
                        totalIndex,
                    };
                    if (oneRow.includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    if (index === 24) {
                        return <TableText data={{ ...props, type: "textcenter", text: "Var%" }} />
                    }
                    if ([42, 45, 49, 52].includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            },
                        }
                    }
                    if (inputIndex.includes(index)) props.type = "inputPercent";
                    return <TableText data={props} />
                }
            }]
        }, {
            title: `YTD-${month}`,
            align: "center",
            children: [{
                title: 'Actual',
                dataIndex: 'y_act',
                key: 'y_act',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    let props = {
                        text,
                        index,
                        type: percentIndex.includes(index) ? "percent" : 'number',
                        name: "y_act",
                        onChange,
                        totalIndex,
                    };
                    if ([...oneRow, 52].includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    if (index === 24) {
                        return <TableText data={{ ...props, type: "textcenter", text: "Actual" }} />
                    }
                    if ([42, 49].includes(index)) {
                        return {
                            props: {
                                colSpan: 3
                            },
                            children: <TableText data={{ ...props, type: 'input' }} />
                        }
                    }
                    if (index == 45) {
                        return {
                            props: {
                                colSpan: 3
                            },
                            children: <TableText data={{ ...props, type: 'inputPercent' }} />
                        }
                    }
                    if (inputIndex.includes(index)) props.type = "inputNumber";
                    return <TableText data={props} />
                }
            }, {
                title: 'Budget',
                dataIndex: 'y_bud',
                key: 'y_bud',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    let props = {
                        text,
                        index,
                        type: percentIndex.includes(index) ? "percent" : 'number',
                        name: "y_bud",
                        onChange,
                        totalIndex,
                    };
                    if (oneRow.includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    if ([42, 45, 49, 52].includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            },
                        }
                    }
                    if (index === 24) {
                        return <TableText data={{ ...props, type: "textcenter", text: "Last Year" }} />
                    }
                    if (inputIndex.includes(index)) props.type = "inputNumber";
                    return <TableText data={props} />
                }
            }, {
                title: 'Var%',
                dataIndex: 'y_var',
                key: 'y_var',
                align: "center",
                width: 150,
                render: (text, record, index) => {
                    let props = {
                        text,
                        index,
                        type: 'percent',
                        name: "y_var",
                        onChange,
                        totalIndex,
                    };
                    if (oneRow.includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            }
                        }
                    }
                    if ([42, 45, 49, 52].includes(index)) {
                        return {
                            props: {
                                colSpan: 0
                            },
                        }
                    }
                    if (index === 24) {
                        return <TableText data={{ ...props, type: "textcenter", text: "Var%" }} />
                    }
                    if (inputIndex.includes(index)) props.type = "inputPercent";
                    return <TableText data={props} />
                }
            }]
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/monthlyReview/compute.js